import React from 'react';
import {Container} from 'react-bootstrap';
import ReactTooltip from "react-tooltip";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import Utilities from '../util/Utilities';
import RespUtils from '../util/RespUtils';
import UIUtils from '../util/UIUtils';
import ChartTitle from '../components/ChartTitle';
import tooltips from '../tooltips';
import MainUtils from "../main/MainUtils";
import '../styles/section.css';
import '../styles/tables.css';
import ProjectUIUtils from '../projects/ProjectUIUtils';
import LogoUtils from '../util/LogoUtils';
import RelayerUtils from './RelayerUtils';

class RelayerInline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chainConfig: [],
    };
  }

  async componentDidMount() {
    RelayerUtils.loadChainConfig(this);
  }

  render() {
    return (
      <React.Fragment>
        <ReactTooltip id="main" place="top" type="dark" effect="float" multiline={true} />
        <Container fluid className="containerLayout container-fluid chartContainer">
          <div className="chartGridContainer">
            <div className="chartBg">{this.renderBasicDetails()}</div>
            {this.props.addresses && <div className="chartBg" id="addresses">{this.renderAddresses()}</div>}
            {this.props.relayer.twitter != null && (<div className="chartBg">{ProjectUIUtils.getTwitterTimeline(this.props.relayer.twitter)}</div>)}
          </div>
        </Container>
        {/* {this.props.addresses && <div>{this.renderAddresses()}</div>} */}
      </React.Fragment>
    );
  }

  renderBasicDetails() {
    return (
      <React.Fragment>
        <ChartTitle title="Relayer Details" tip={tooltips.relayers.basic} />
        <table>
            <tbody>
              <tr>
                <td>Name: </td>
                <td> {LogoUtils.formatLogoByPath(this.props.relayer.logoPath, this.props.relayer)} {MainUtils.nameFormatterLong(this.props.relayer.name, this.props.relayer)}</td>
              </tr>
              <tr>
                <td>Media: </td>
                <td> {ProjectUIUtils.formatMedia(this.props.relayer.twitter, this.props.relayer)}</td>
              </tr>
              <tr>
                <td>Chains Relayed (Logo): </td>
                <td> {RelayerUtils.formatRelChains(this.props.relayer.chainsRelayed, this.props.relayer, 0, this.state.chainConfig)}</td>
              </tr>
              <tr>
                <td>Chains Relayed (Ticker): </td>
                <td> {RelayerUtils.formatRelChainsText(this.props.relayer.chainsRelayed, this.props.relayer, 0, this.state.chainConfig)}</td>
              </tr>
              <tr>
                <td>Chains Validated: </td>
                <td> {RelayerUtils.formatValChains(this.props.relayer.chainsValidated, this.props.relayer, 0, this.state.chainConfig)}</td>
              </tr>
              <tr>
                <td>Support Relayer By: </td>
                <td> {this.props.relayer.supportRelayerBy}</td>
              </tr>
            </tbody>
        </table>
      </React.Fragment>
    );
  }

  renderAddresses() {
    var columns = [
      {text: "#", hidden: RespUtils.isMobileView(), dataField: "index", sort: true, headerStyle: Utilities.respWidth(5, 4, 3)},
      {text: "Chain", dataField: "app", formatter: RelayerUtils.formatRelChainWithStatus, formatExtraData: this.state.chainConfig, sort: true, headerStyle: Utilities.respWidth(35, 30, 25)},
      {text: "Address", dataField: "address", formatter: RelayerUtils.relayerAddressFormatter, formatExtraData: this.state.chainConfig, sort: true, headerStyle: Utilities.respWidth(35, 25, 20)},
      {text: Utilities.respLabel("Balance", "Balance", "Balance"), dataField: "balance", formatter: RelayerUtils.formatCoins, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 15, 8)},
      {text: "8H Txs", dataField: "currentDelta", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 15, 8)},
      {text: "1D Txs", hidden: RespUtils.isTabletView(), dataField: "dailyDelta", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 15, 8)},
      {text: "7D Txs", hidden: RespUtils.isTabletView(), dataField: "weeklyDelta", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 15, 8)},
      {text: "30D Txs", hidden: RespUtils.isTabletView(), dataField: "monthlyDelta", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 15, 8)},
    ];
    
    const options = UIUtils.getPageOptionsSmall(this, 5);

    return (
      <React.Fragment>
        <ChartTitle title="Chains and Addresses" tip={tooltips.relayers.addresses} fsElementId="addresses" />
        <BootstrapTable keyField='index' data={ this.props.addresses }
          columns={ columns } striped options={options}
          condensed noDataIndication="No data" pagination={ paginationFactory(options) }/>
        <p>**Tx count shown is simply a delta change in address nonce and may be inaccurate. Each record above represents a unique address used by the relayer.</p>
        <p>Update your (or your favorite) relayer's data at <a href="https://github.com/SmartStake/relayers" target="_blank" title="github" className="mediaCustom fab fa-github fa-md"> Github</a></p>
      </React.Fragment>
    )
  }


}


export default RelayerInline;
